import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import de from '../locales/de.json';
import en from '../locales/en.json';
import countries from "i18n-iso-countries";

export const defaultLng = 'en';

class I18nService {

    init(){
        i18next.use(initReactI18next).init({
            lng: this.getUsedLanguage(),
            debug: true,
            resources: {
                fr: {
                    translation: fr,
                },
                en: {
                    translation: en
                },
                de: {
                    translation: de
                },
                es: {
                    translation: es
                }
            },
            fallbackLng: defaultLng
        });
    }

    getUsedLanguage(): string{
        let language = new URLSearchParams(window.location.search).get("language") || new URLSearchParams(window.location.search).get("Language") || "en";
        language = language.toLowerCase();

        if (language.length > 2) {
            language = language.split("-")[0];
            language = language.split("_")[0];
        }

        if(!this.getLanguages().includes(language)){
            language = "en";
        }

        return language;
    }

    getLanguages(): string [] {
        return ["en","fr","de","es"];
    }

    getNativeLanguageName(alpha2code: "fr" | "en" | "de" | "es"): string {
      const nativeLanguages : Record<typeof alpha2code, string> = {
          "fr": "français",
          "en": "English",
          "de": "Deutsch",
          "es": "Español"
      }
      return nativeLanguages[alpha2code];
    };

    getSupportedCountriesForSelect(): {value: string; label: string}[] {
        const supportedCountries = ["FR","DE","ES","AT","IT","NL","BE","IE"];
        return supportedCountries.map((alphaCode2) => {
            const label = countries.getName(
                alphaCode2,
                this.getUsedLanguage(),
                {select: "official"}
            );

            return {
                value: alphaCode2,
                label: label || alphaCode2
            };
        })
    }

    getAllCountriesForSelect() {
        const allCountries = countries.getNames(this.getUsedLanguage());
        return Object.getOwnPropertyNames(allCountries).map((key) => {
            return { label: allCountries[key], value: key };
        });
    }
 }


 export default new I18nService();
